module.exports = __webpack_public_path__ + "static/images/banner.1c0aa82.png";